import React from 'react';
import { Calendar, ChevronRight } from 'lucide-react';
import { News } from '../../../types/contentTypes';
import { getNewsCategoryLabel } from '../../../utils/categoryHelpers';

interface NewsDetailProps {
  news: News;
  onBack: () => void;
}

const NewsDetail: React.FC<NewsDetailProps> = ({ news, onBack }) => {
  return (
    <div>
      <button 
        onClick={onBack}
        className="text-primary hover:text-primary-700 font-medium flex items-center mb-6"
      >
        <ChevronRight className="h-4 w-4 mr-1 rotate-180" />
        Nazaj na seznam
      </button>
      
      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        <div className="h-96 overflow-hidden">
          <img 
            src={news.image} 
            alt={news.title} 
            className="w-full h-full object-cover" 
          />
        </div>
        <div className="p-6 md:p-8">
          <div className="flex flex-wrap gap-3 mb-4">
            <span className="bg-primary/10 text-primary text-sm font-medium px-3 py-1 rounded-full">
              {getNewsCategoryLabel(news.category)}
            </span>
            <span className="bg-gray-100 text-gray-700 text-sm px-3 py-1 rounded-full flex items-center">
              <Calendar className="h-4 w-4 mr-1" />
              {new Date(news.date).toLocaleDateString('sl-SI')}
            </span>
          </div>
          
          <h1 className="text-3xl font-bold text-secondary mb-4">{news.title}</h1>
          <p className="text-gray-700 text-lg mb-6">{news.excerpt}</p>
          
          <div className="prose max-w-none">
            {news.content.split('\n\n').map((paragraph, index) => (
              <p key={index} className="mb-4 text-gray-700">{paragraph}</p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsDetail;